import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

const override = {
  display: 'block',
  margin: '0 auto',
  padding: "25%",
  borderColor: 'rgb(0, 43, 54)', // sets the border color, not the spinner fill
};

const SweetLoadingSpinner = ({ loadingState }) => (
  <div className="sweet-loading">
    <ClipLoader
      cssOverride={override}   // ✅ new prop name
      size={150}
      color="#123abc"           // ✅ spinner color
      loading={loadingState}
    />
  </div>
);

export default SweetLoadingSpinner;
